import { useState } from "react";
import { Link } from "react-router";
import { useMe, useStatusBar } from "@/api/queries";
import { Button } from "@/components/ui/controls";
import { Glyph } from "@/components/ui/Glyph";
import { HOLD_EFFECT, liftBlocked } from "./hold";
import { LiftDialog } from "./HoldDialogs";
import styles from "./hold.module.css";

/**
 * While automatic fixes are on hold, every screen says so first: who held them, when and why,
 * what that means, and (for admins) the way to lift it. Amber, because a person decides every
 * fix until then.
 */
export function HoldBanner({ compact = false }: { compact?: boolean }) {
  const status = useStatusBar();
  const me = useMe();
  const [lifting, setLifting] = useState(false);
  const hold = status.data?.hold;
  if (!hold?.on) return null;
  const canLift = liftBlocked(hold, me.data?.permissions ?? []) === null;

  return (
    <div className={`${styles.banner} ${compact ? styles.compact : ""}`} role="status">
      <span className={styles.icon} aria-hidden="true">
        <Glyph name="pause" size={14} strokeWidth={2.6} />
      </span>
      <p className={styles.text}>
        <strong className={styles.strong}>Automatic fixes are on hold.</strong> {hold.detail}{" "}
        {compact ? null : <span className={styles.effect}>{HOLD_EFFECT}</span>}
      </p>
      {canLift ? (
        <Button size="sm" variant="field" className={styles.lift} onClick={() => setLifting(true)}>
          Lift the hold
        </Button>
      ) : compact ? null : (
        <Link to="/autonomy" className={styles.more}>
          Autonomy
        </Link>
      )}
      {lifting ? (
        <LiftDialog deployment={hold.deployment} onClose={() => setLifting(false)} />
      ) : null}
    </div>
  );
}
